import {Component, inject} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';

import {ApplicationsAutoriseesService} from '../applications-autorisees.service';
import {JetonContexteService} from '../jeton-contexte.service';
import {FonteIconeComponent} from '../../../../val-ammon-composants/val-composants-lib/src/public-api';

//Page présentée à l’utilisateur qui ouvre une application dont il n’a pas l’autorisation
//  Elle ne dit ni le code de l’application, ni le nom du groupe attendu, ni la raison technique
//  du refus : l’utilisateur n’a rien à en faire, et son administrateur les connaît. Elle ne
//  redirige pas non plus vers une autre application — rien ne garantit qu’il en ait une.
//  Cf. ADR-0017, décision D11.
@Component (
{
  selector: 'val-page-acces-refuse',
  imports: [FonteIconeComponent],
  templateUrl: './page-acces-refuse.component.html',
  styleUrl: './page-acces-refuse.component.scss'
})
export class PageAccesRefuseComponent
{
  //Déconnecte l’utilisateur
  public Deconnecter () : void
  {
    //Le jeton de contexte et les applications résolues survivraient à la déconnexion : ils vivent
    //dans le sessionStorage, que logOut ne purge pas.
    this.jetonContexteService.Effacer ();
    this.applicationsAutoriseesService.Effacer ();

    sessionStorage.removeItem ("code_client");

    this.oAuthService.logOut ();
  }

  private readonly applicationsAutoriseesService = inject (ApplicationsAutoriseesService);
  private readonly jetonContexteService = inject (JetonContexteService);
  private readonly oAuthService = inject (OAuthService);
}
